const RayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.00048 13.9999C3.81125 14.0006 3.62571 13.9475 3.46543 13.8469C3.30516 13.7463 3.17671 13.6023 3.09503 13.4316C3.01335 13.2609 2.98177 13.0705 3.00398 12.8826C3.02619 12.6946 3.10126 12.5169 3.22048 12.3699L13.1205 2.16992C13.1947 2.0842 13.2959 2.02628 13.4075 2.00565C13.519 1.98503 13.6342 2.00293 13.7342 2.05642C13.8342 2.10991 13.9131 2.19582 13.9578 2.30003C14.0026 2.40424 14.0106 2.52057 13.9805 2.62992L12.0605 8.64992C12.0039 8.80144 11.9849 8.96444 12.0051 9.12493C12.0253 9.28541 12.0841 9.4386 12.1766 9.57135C12.269 9.70409 12.3923 9.81243 12.5358 9.88708C12.6793 9.96172 12.8387 10.0004 13.0005 9.99992H20.0005C20.1897 9.99927 20.3752 10.0523 20.5355 10.1529C20.6958 10.2535 20.8242 10.3976 20.9059 10.5683C20.9876 10.739 21.0192 10.9293 20.997 11.1173C20.9748 11.3052 20.8997 11.483 20.7805 11.6299L10.8805 21.8299C10.8062 21.9156 10.705 21.9736 10.5935 21.9942C10.482 22.0148 10.3668 21.9969 10.2668 21.9434C10.1667 21.8899 10.0879 21.804 10.0431 21.6998C9.9984 21.5956 9.9904 21.4793 10.0205 21.3699L11.9405 15.3499C11.9971 15.1984 12.0161 15.0354 11.9959 14.8749C11.9757 14.7144 11.9168 14.5612 11.8244 14.4285C11.732 14.2957 11.6087 14.1874 11.4652 14.1128C11.3217 14.0381 11.1622 13.9994 11.0005 13.9999H4.00048Z"
        stroke="#01A76A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RayIcon
